export default "__VITE_ASSET__1e4fe2d4__"